import RestResource from '../rest.service';

export default class QuotationStatesService extends RestResource {
  getColors() {
    return ['warning', 'primary', 'success'];
  }

  constructor() {
    super('quotation-states');
  }
}
